<template>
  <div class="cascading-elements-tree-component">

    <el-alert
      v-if="websocket.state === 3"
      style="width: 710px; position: absolute; top:-46px; right: 0;"
      title="Внимание. Невозможно подключиться к Web Socket. Данные могут быть не синхронизированы"
      type="error"
      show-icon
    ></el-alert>

    <div>
      <div style="display: flex; justify-content: space-between">
        <div>
          <el-button
            :disabled="!addButtonEnabled"
            style="display: inline-block"
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="createChildNode"
          >
            Добавить цель
          </el-button>

        </div>

        <el-radio-group v-model="viewMode" size="small" class="view-mode-radio-group">
          <el-radio-button label="my">Мои планирования</el-radio-button>
          <el-radio-button label="shared" disabled>Доступные планирования</el-radio-button>
          <el-radio-button label="element" disabled>Просмотр цели</el-radio-button>
        </el-radio-group>





        <div>
          <cascading-permissions-profiles-edit-modal style="display: inline-block">
            <el-button
              slot="reference"
              size="small"
              plain
              icon="fas fa-user-tag"
            >
              Профили полномочий
            </el-button>
          </cascading-permissions-profiles-edit-modal>

          <cascading-quality-scale-templates-edit-modal style="display: inline-block; margin-left: 20px">
            <el-button
              slot="reference"
              size="small"
              plain
              icon="fas fa-pen"
            >
              Шаблоны качественных шкал
            </el-button>
          </cascading-quality-scale-templates-edit-modal>

          <CascadingCardScaleTemplatesEditModal style="display: inline-block;margin-left: 20px">
            <el-button
              slot="reference"
              size="small"
              plain
              icon="fas fa-pen"
            >
              Шаблоны шкал в картах
            </el-button>
          </CascadingCardScaleTemplatesEditModal>

          <library-scales-units-modal
            v-if="$canAndRulesPass(user, 'scales.edit_units')"
            style="display: inline-block; margin-left: 20px"
          >
            <el-button
              slot="reference"
              size="small"
              icon="fas fa-coins"
            >
              Единицы измерения
            </el-button>
          </library-scales-units-modal>
        </div>

      </div>
    </div>


    <div class="cascading-elements-tree-table" style="margin-top: 10px">
      <div class="cascading-elements-tree-header">
        <div class="cascading-elements-tree-cell" style="width: 10px;border-left: 1px solid #EBEEF5;"></div>
        <div class="cascading-elements-tree-cell" style="flex: 1;">Название</div>
        <div v-if="columns.includes('weight')" class="cascading-elements-tree-cell" style="width: 30px;">Вес</div>
        <div v-if="columns.includes('value')" class="cascading-elements-tree-cell" style="width: 200px;">Значение</div>
        <div v-if="columns.includes('scale_unit')" class="cascading-elements-tree-cell" style="width: 200px;">Ед.изм. / Тип шкалы</div>
        <div v-if="columns.includes('baseline')" class="cascading-elements-tree-cell" style="width: 200px;">Базовое</div>
        <div v-if="columns.includes('target')" class="cascading-elements-tree-cell" style="width: 200px;">Целевое</div>
        <div v-if="columns.includes('progress')" class="cascading-elements-tree-cell" style="width: 70px;">Прогресс</div>
        <div v-if="columns.includes('performance')" class="cascading-elements-tree-cell" style="width: 160px;">Производительность</div>
        <div class="cascading-elements-tree-cell" style="width: 14px;">
          <cascading-tree-columns-visible-edit-modal
            ref="columnVisibleModal"
            @change="initColumns"
          >
            <el-button
              slot="reference"
              style="margin-top: 0; padding-top: 0; color: gray"
              size="mini"
              type="text"
              plain
              icon="far fa-eye"
            ></el-button>
          </cascading-tree-columns-visible-edit-modal>
        </div>
      </div>


      <VueNestable
        v-if="rootNode"
        v-loading="rootNode.loading"
        ref="elementsTree"
        class="cascading-elements-tree"
        v-model="rootNode.childrenNodes"
        key-prop="hash"
        children-prop="childrenToShow"
        class-prop="class"
        pre-apply-drag
        @on-drag-end="beforeNodeDropped"
      >
        <template v-slot:placeholder>
          <div
            style="border: 1px solid #EBEEF5; text-align: center; padding: 10px; color: #909399"
            class="cascading-elements-tree-row"
          >
            Нет созданных планов. Начните новое планирование с нажатия на кнопку "Добавить цель"
          </div>
        </template>
        <template slot-scope="{ item: node }">


          <div
            :id="'cascading-element-'+node.id"
            style="border-left: 1px solid #EBEEF5;"
            class="cascading-elements-tree-row"
            :class="{'selected-row': (selectedNode && node.id === selectedNode.id)}"
            v-loading="node.loading"
            @click="rowClicked(node)"
            @dblclick="rowDblClicked(node)"
          >

            <div
              v-for="parentLink in node.otherParentsLinks"
              class="cascading-elements-tree-row-link"
            >
              <div>
                <router-link
                  :to="{
                    name: 'CascadingElements',
                    params: {
                      element_id: node.id,
                      parent_id: parentLink.parent_id,
                    }
                  }"
                  @click.stop
                >
                  <el-button
                    style="padding: 0"
                    type="text"
                  >
                    <i class="fas fa-link" style="margin-right: 10px"></i>
                    {{ parentLink.parent_element.name }}
                  </el-button>

                </router-link>
              </div>
            </div>


            <div class="cascading-elements-tree-row-main">
              <VueNestableHandle :item="node" class="cascading-elements-tree-cell" style="width: 10px;">
                <i class="fas fa-bars" style="color: #c0c0c0"/>
              </VueNestableHandle>

              <div class="cascading-elements-tree-cell" style="width: 13px; border-right: unset; padding-right: 0;padding-top:0">
                <el-button
                  v-if="node.hasChildren"
                  size="mini"
                  type="text"
                  :loading="node.loading"
                  @click.stop="toggleNodeExpand(node)"
                >
                  <i :class="node.expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
                </el-button>
              </div>

              <div
                class="cascading-elements-tree-cell"
                style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; flex: 1;"
              >
                <div style="display: flex; justify-content: space-between">
                  <click-to-edit
                    v-model="node.model.name"
                    :placeholder="node.getHiddenPlaceholder('name')"
                    disabled
                  ></click-to-edit>
                  <div>
                    <el-tooltip
                      v-if="node.isFieldViewable('responsible_id') && node.model.responsible_id"
                      class="cascading-elements-tree-helper-icon"
                      content="Есть ответственный"
                      placement="top"
                      :open-delay="500"
                    >
                      <i class="fas fa-user-tie"></i>
                    </el-tooltip>
                    <el-tooltip
                      v-if="node.model.auto_cascaded"
                      class="cascading-elements-tree-helper-icon"
                      content="Получена каскадированием"
                      placement="top"
                      :open-delay="500"
                    >
                      <i class="fas fa-network-wired"></i>
                    </el-tooltip>
                    <el-tooltip
                      v-if="node.isFieldViewable('card_id') && node.model.card_id"
                      class="cascading-elements-tree-helper-icon"
                      content="Назначена в карту"
                      placement="top"
                      :open-delay="500"
                    >
                      <i class="far fa-address-card"></i>
                    </el-tooltip>

                  </div>
                </div>
              </div>

              <div v-if="columns.includes('weight')" class="cascading-elements-tree-cell" style="width: 30px;">
                <div v-if="node.thisParentLink">{{node.thisParentLink.weight}}</div>
                <div v-else>&nbsp;</div>
              </div>

              <div v-if="columns.includes('value')" class="cascading-elements-tree-cell" style="width: 200px;">
                <CascadingScalePerformanceValuesInput
                  v-model="node.model"
                  disabled
                  :placeholder="node.getHiddenPlaceholder('value')"
                  performance-value-name="value"
                  style="width: 100%"
                  @change="updateNode(node)"
                ></CascadingScalePerformanceValuesInput>
              </div>

              <div v-if="columns.includes('scale_unit')" class="cascading-elements-tree-cell" style="width: 200px;">
                <cascading-scale-unit-select
                  v-if="node.isFieldViewable('scale_unit')"
                  v-model="node.model"
                  disabled
                  @change="updateNode(node)"
                ></cascading-scale-unit-select>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('scale_unit')}}</CascadingElementHiddenProp>
              </div>


              <div v-if="columns.includes('baseline')" class="cascading-elements-tree-cell" style="width: 200px;">
                <CascadingScalePerformanceValuesInput
                  v-model="node.model"
                  disabled
                  :placeholder="node.getHiddenPlaceholder('baseline')"
                  performance-value-name="baseline"
                  style="width: 100%"
                  @change="updateNode(node)"
                />
              </div>

              <div v-if="columns.includes('target')" class="cascading-elements-tree-cell" style="width: 200px;">
                <CascadingScalePerformanceValuesInput
                  v-model="node.model"
                  disabled
                  :placeholder="node.getHiddenPlaceholder('target')"
                  performance-value-name="target"
                  style="width: 100%"
                  @change="updateNode(node)"
                />
              </div>

              <div v-if="columns.includes('progress')" class="cascading-elements-tree-cell " style="width: 70px;">
                <click-to-edit
                  v-model="node.model.progress"
                  :placeholder="node.getHiddenPlaceholder('progress')"
                  disabled
                ></click-to-edit>
              </div>
              <div v-if="columns.includes('performance')" class="cascading-elements-tree-cell" style="width: 160px;">
                <click-to-edit
                  v-model="node.model.performance"
                  :placeholder="node.getHiddenPlaceholder('performance')"
                  disabled
                ></click-to-edit>
              </div>


              <div class="cascading-elements-tree-cell" style="width: 14px;">
                <el-popconfirm
                  v-if="node.isActionAllowed('delete')"
                  confirm-button-text="Да"
                  cancel-button-text="Нет"
                  icon="el-icon-question"
                  title="Вы уверены, что хотите удалить элемент?"
                  @confirm="deleteNode(node)"
                >
                  <el-button
                    style="margin-top:-5px; margin-left:-5px"
                    slot="reference"
                    class="table-action-button"
                    round
                    icon="far fa-trash-alt"
                    @click.stop
                  ></el-button>
                </el-popconfirm>
              </div>
            </div>
          </div>
        </template>
      </VueNestable>
    </div>

    <ElementsTreeNodeSettingsPanel
      :node="selectedNode"
      class="cascading-elements-tree-settings-panel"
      @update-node="updateNode"
      @update-node-parent-link="updateNodeParentLink($event.node, $event.parentLink)"
      @assign-node-to-card="assignNodeToCard($event.node, $event.cardId)"
      @run-auto-cascading="runAutoCascading($event.node)"
    ></ElementsTreeNodeSettingsPanel>

    <div
      class="cascading-elements-context-menu-overlay"
      v-if="elementDnDContextMenu.visible"
    >
      <div
        id="cascading-elements-context-menu"
        class="cascading-elements-context-menu"
        :style="{ top: elementDnDContextMenu.y + 'px', left: elementDnDContextMenu.x + 'px' }"
      >
        <div><el-button :disabled="!elementDnDContextMenu.node.isActionAllowed('move')" icon="fas fa-arrows-alt" size="mini" @click="elementDnDContextMenuSelectOption('move')">Переместить</el-button></div>
        <div><el-button :disabled="!elementDnDContextMenu.node.isActionAllowed('copy')" icon="fas fa-copy" size="mini" @click="elementDnDContextMenuSelectOption('copy')">Копировать</el-button></div>
<!--        <div><el-button icon="fas fa-copy" size="mini" @click="elementDnDContextMenuSelectOption('copy_with_child')">Копировать с дочерними</el-button></div>-->
        <div><el-button :disabled="!elementDnDContextMenu.node.isActionAllowed('link')" icon="fas fa-link" size="mini" @click="elementDnDContextMenuSelectOption('link')">Связать</el-button></div>
        <div><el-button icon="fas fa-times" size="mini" style="margin-top: 10px" @click="elementDnDContextMenuSelectOption('cancel')">Отмена</el-button></div>
      </div>
    </div>



  </div>
</template>


<script>
import VueNestable from "@/components/vueNestable/VueNestable.vue";
import VueNestableHandle from "@/components/vueNestable/VueNestableHandle.vue";
import 'vue-nestable/example/assets/vue-nestable.css'
import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingScaleUnitSelect from "@/modules/cascading/components/scale/CascadingScaleUnitSelect.vue";
import CascadingScalePlanInput from "@/modules/cascading/components/scale/CascadingScalePlanInput.vue";
import CascadingScaleFactInput from "@/modules/cascading/components/scale/CascadingScaleFactInput.vue";
import CascadingQualityScaleTemplatesEditModal
  from "@/modules/cascading/components/scale/CascadingQualityScaleTemplatesEditModal.vue";
import ElementsTreeNode from "@/modules/cascading/components/ElementsTree/ElementsTreeNodeClass";
import ElementsTreeNodeSettingsDialog
  from "@/modules/cascading/components/ElementsTree/ElementsTreeNodeSettingsDialog.vue";
import WSClient from "@/components/webSocket/WSClient";
import CascadingScalePerformanceValuesInput
  from "@/modules/cascading/components/scale/CascadingScalePerformanceValuesInput.vue";
import CascadingCardScaleTemplatesEditModal
  from "@/modules/cascading/components/cardScale/CascadingCardScaleTemplatesEditModal.vue";
import ElementsTreeNodeSettingsPanel
  from "@/modules/cascading/components/ElementsTree/ElementsTreeNodeSettingsPanel.vue";
import LibraryScalesUnitsModal from "@/components/library/LibraryScalesUnitsModal.vue";
import {mapGetters} from "vuex";
import ApiPlugin from "@/api/base";
import CascadingPermissionsProfilesEditModal
  from "@/modules/cascading/components/permissionsProfile/CascadingPermissionsProfilesEditModal.vue";
import CascadingElementHiddenProp from "@/modules/cascading/components/CascadingElementHiddenProp.vue";
import CascadingCardScaleTemplateEditModal
  from "@/modules/cascading/components/cardScale/CascadingCardScaleTemplateEditModal.vue";
import CascadingTreeColumnsVisibleEditModal
  from "@/modules/cascading/components/ElementsTree/CascadingTreeColumnsVisibleEditModal.vue";

export default {
  name: 'ElementsTreeComponent',
  components: {
    CascadingTreeColumnsVisibleEditModal,
    CascadingCardScaleTemplateEditModal,
    CascadingElementHiddenProp,
    CascadingPermissionsProfilesEditModal,
    LibraryScalesUnitsModal,
    ElementsTreeNodeSettingsPanel,
    CascadingCardScaleTemplatesEditModal,
    CascadingScalePerformanceValuesInput,
    ElementsTreeNodeSettingsDialog,
    CascadingQualityScaleTemplatesEditModal,
    CascadingScaleFactInput, CascadingScalePlanInput, CascadingScaleUnitSelect,
    ClickToEdit, VueNestable,
    VueNestableHandle,
  },
  props: {
    fromElementId: {type: Number},
    fromParentId: {type: Number},
  },
  computed: {
    ...mapGetters([ 'user' ]),
    addButtonEnabled(){
      const node = this.selectedNode || this.rootNode;
      if( !node ){
        return false;
      }
      return node.isActionAllowed('create_child');
    },
  },

  mounted() {
    this.initColumns();
    this.initTree();
    this.initWebSocket();

  },
  data() {
    return {
      websocket: {},
      columns: [],
      viewMode: null,
      rootNode: null,
      selectedNode: null,
      clickTimeout: null,
      elementDnDContextMenu: {
        node: null,
        visible: false,
        x: 0,
        y: 0,
        resolve: null,
      },
    }
  },

  watch: {
    'viewMode': function (newVal) {
      this.selectedNode = null;
      this.loadByViewMode();
    },
    fromElementId: function(newVal){
      this.reload();
    },
    fromParentId: function(newVal){
      this.reload();
    },
  },

  methods: {
    initColumns() {
      this.columns = this.$refs.columnVisibleModal.getCurrentColumns();
    },

    initTree() {
      if( this.fromElementId ){
        this.viewMode = 'element'
      } else {
        this.viewMode = 'my';
      }
    },

    initWebSocket() {
      this.websocket = new WSClient('cascading');
      this.websocket.on('TreeElementCreated', this.elementCreatedReceived);
      this.websocket.on('TreeElementUpdated', this.elementNewDataReceived);
      this.websocket.on('TreeElementMoved', this.elementMovedReceived);
      this.websocket.on('TreeElementDeleted', this.elementDeletedReceived);
      this.websocket.on('TreeElementLinkCreated', this.elementLinkCreatedReceived);
      this.websocket.on('TreeElementLinkDeleted', this.elementLinkDeletedReceived);
      this.websocket.on('ScaleQualityUpdated', this.scaleQualityUpdatedReceived);
      this.websocket.on('CardScaleUpdated', this.cardScaleUpdatedReceived);
      this.websocket.connect();
    },

    reload(){
      this.initTree();
      this.loadByViewMode();
    },

    loadByViewMode(){
      switch (this.viewMode){
        case 'my':
          this.rootNode = new ElementsTreeNode();
          this.rootNode.toggleExpand();
          break;

        case 'element':
          this.$api.cascading.elementsGetTreeFromElementToRoot({
            element_id: this.fromElementId,
            parent_id: this.fromParentId,
            expand: [
              'scale','has_children',
              'parent_links','parent_links.parent_element',
              'card', 'card.user',
              'permissions'
            ].join(),
          })
            .then(data => {
              this.rootNode = new ElementsTreeNode(data.tree);
              this.selectNodeById(this.fromElementId);
            })
            .finally(() => {
              this.loading = false;
            })
          break;
      }
    },

    rowClicked(node) {
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout);
        this.clickTimeout = null;
      }

      this.clickTimeout = setTimeout(() => {
        if( this.selectedNode && this.selectedNode.id === node.id ){
          this.selectedNode = null;
        } else {
          this.selectedNode = node;
          this.scrollToNodeId(node.id);
        }
      }, 250);
    },
    rowDblClicked(node) {
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout);
        this.clickTimeout = null;
      }
      node.expand();
    },

    createChildNode() {
      const node = this.selectedNode || this.rootNode;

      node.createChild()
        .then(newNode => {
          this.selectNodeById(newNode.id);
        })
    },

    selectNodeById(nodeId){
      this.$nextTick(function () {
        const el = document.getElementById('cascading-element-'+nodeId);
        if (el) {
          el.click();
          this.scrollToNodeId(nodeId);
        }
      })
    },
    scrollToNodeId(nodeId){
      const el = document.getElementById('cascading-element-'+nodeId);
      // Нужен т.к. панель параметров открывается после клика
      this.$nextTick(function () {
        el.scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      })
    },

    updateNode(node) {
      node.save();
    },
    updateNodeParentLink(node, parentLink) {
      node.saveParentLink(parentLink);
    },
    assignNodeToCard(node, cardId) {
      node.assignToCard(cardId);
    },

    runAutoCascading(node) {
      node.runAutoCascading();
    },

    toggleNodeExpand(node) {
      node.toggleExpand();
    },

    deleteNode(node) {
      if( node.otherParentsLinks.length ){
        this.$confirm(
          'У этой цели есть связь с другими целями. Вы хотите удалить текущую связь или цель полностью?',
          'Confirm',
          {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Текущую связь',
          cancelButtonText: 'Цель полностью'
        })
          .then(() => {
            node.unlink();
          })
          .catch(action => {
            if( action === 'cancel' ){
              node.delete();
            } else {
              // Тут просто закрыли окно, ничего не делаем
            }
          });
      } else {
        node.delete();
      }

      if( this.selectedNode?.id === node.id ){
        this.selectedNode = null;
      }
    },


    elementCreatedReceived(elementData) {
      elementData.parent_links.forEach(parentLink => {
        if( parentLink.parent_id === this.rootNode.id ){ // Пришла для рута
          this.rootNode.appendChildFromData(elementData);
          return;
        }
        const node = this.$refs.elementsTree.getItemById(parentLink.parent_id);
        if (!node) {
          return;
        }
        node.appendChildFromData(elementData);
      })
    },

    elementMovedReceived(data) {
      // Нод с одним id может быть несколько, но с разными родителями. Ищем все, потом отфильтруем
      const movedNodes = this.$refs.elementsTree.getAllItemsById(data.element.id);

      function moveItemById(arr, id, newIndex) {
        const currentIndex = arr.findIndex(item => item.id === id);
        if (currentIndex === -1 || currentIndex === newIndex){
          return arr;
        }
        const [item] = arr.splice(currentIndex, 1);
        arr.splice(newIndex, 0, item);

        return arr;
      }

      let savedNode = [];

      movedNodes.forEach(movedNode => {
        if( movedNode.parentNode?.id !== data.oldParentId ){ // Это нода с другим родителем, нам не интересно
          return;
        }

        if( data.oldParentId === data.newParentId ){ // Значит только поменялся порядок, не нужно удалять, только переместить в массиве
          movedNode.parentNode.childrenNodes = moveItemById(movedNode.parentNode.childrenNodes, data.element.id, data.newOrder-1 );

        } else { // Значит поменялся родитель. Сначала забираем у родителя, и его же вставляем в дочерний, если он есть

          const movedNodeOldParentIndex = movedNode.parentNode.childrenNodes.findIndex(item => item.id === movedNode.id);


          if (movedNodeOldParentIndex !== -1 ){
            [savedNode] = movedNode.parentNode.childrenNodes.splice(movedNodeOldParentIndex, 1);
          }
          if( !movedNode.parentNode.childrenNodes.length ){
            movedNode.parentNode.expanded = false;
            movedNode.parentNode.hasChildren = false;
          }
        }
      });


      // Теперь вставляем в нового родителя
      const newParentNodes = this.$refs.elementsTree.getAllItemsById(data.newParentId);
      if( this.rootNode.id === data.newParentId ){
        newParentNodes.push(this.rootNode);
      }
      newParentNodes.forEach(newParentNode => {
        if( !newParentNode.expanded ){
          newParentNode.hasChildren = true;
          return;
        }

        const movedNodeNewParentIndex = newParentNode.childrenNodes.findIndex(item => item.id === data.element.id);
        if( movedNodeNewParentIndex !== -1 ){ // Значит это браузер, где ее перемещали, ничего делать не нужно
          return;
        }

        if( savedNode && savedNode.length ){
          savedNode.parentNode = newParentNode;
          savedNode.thisParentLink = data.element.parent_links.find(l => l.parent_id === newParentNode.id);
          savedNode.otherParentsLinks = data.element.parent_links.filter(l => l.parent_id !== newParentNode.id);
          newParentNode.childrenNodes.splice(data.newOrder-1, 0, savedNode);
        } else {
          newParentNode.appendChildFromData(data.element);
          newParentNode.childrenNodes = moveItemById(newParentNode.childrenNodes, data.element.id, data.newOrder-1 );
        }
      })

    },

    elementNewDataReceived(elementData) {
      const nodes = this.$refs.elementsTree.getAllItemsById(elementData.id);
      nodes.forEach(node => {
        node.model = elementData;
      })
    },

    elementDeletedReceived(elementId) {
      if( this.selectedNode?.id === elementId ){
        this.selectedNode = null;
      }

      const nodes = this.$refs.elementsTree.getAllItemsById(elementId);
      nodes.forEach(node => {
        node.removeFromList();
      })
    },

    elementLinkCreatedReceived(linkData) {
      const nodes = this.$refs.elementsTree.getAllItemsById(linkData.child_id);
      nodes.forEach(node => {
        if( node.parentNode.id === linkData.parent_id ){
          return;
        }
        node.otherParentsLinks.push(linkData);
      });
    },
    elementLinkDeletedReceived(data) {
      const nodes = this.$refs.elementsTree.getAllItemsById(data.element_id);
      nodes.forEach(node => {
        if( node.parentNode.id === data.parent_id ){
          node.removeFromList();
        }

        // Чистим в связях с другими элементами
        const linkIndex = node.otherParentsLinks.findIndex(link => link.parent_id === data.parent_id);
        if (linkIndex !== -1){
          node.otherParentsLinks.splice(linkIndex, 1);
        }
      });
    },
    scaleQualityUpdatedReceived(data){
      const nodes = this.$refs.elementsTree.getAllItems();
      nodes.forEach(node => {
        if( node.model.scale_type === this.$cascadingConstants.scales.types.TYPE_QUALITY && node.model.scale_id === data.id ){
          this.$set(node.model, 'scale', data);
        }
      });
    },
    cardScaleUpdatedReceived(data){
      const nodes = this.$refs.elementsTree.getAllItems();
      nodes.forEach(node => {
        if( node.model.card_scale.id === data.id ){
          this.$set(node.model, 'card_scale', data);
        }
      });
    },




    async showElementDnDContextMenu(droppedNode, x, y) {
      this.elementDnDContextMenu.visible = true;
      this.elementDnDContextMenu.node = droppedNode;
      this.elementDnDContextMenu.x = x;
      this.elementDnDContextMenu.y = y;

      await this.$nextTick();

      let menuEl = document.getElementById('cascading-elements-context-menu');
      const menuElRect = menuEl.getBoundingClientRect();
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      const bottomOfMenu = menuElRect.y + menuElRect.height;
      const notVisiblePixels = bottomOfMenu - viewHeight;
      if( notVisiblePixels > 0 ){
        this.elementDnDContextMenu.y -= notVisiblePixels;
      }

      return new Promise(resolve => {
        this.elementDnDContextMenu.resolve = resolve;
      });
    },
    elementDnDContextMenuSelectOption(action) {
      if (this.elementDnDContextMenu.resolve) {
        this.elementDnDContextMenu.resolve(action);
      }
      this.elementDnDContextMenu.visible = false;
    },


    async beforeNodeDropped(droppedNode, newPathData, apply, revert, stopTracking) {
      if( !newPathData.pathTo ){
        // Значит элемент вообще не перемещался
        revert();
        return;
      }
      // newPathData состоит из 2 свойств.
      // items - Новое представление дерева нод
      // pathTo - массив индексов нод в массиве items,
      // пройдя по которому мы доберемся до новой позиции перемещаемой ноды
      if( !newPathData.pathTo.length ){
        console.error('Smth wrong with new path data');
        return;
      }

      const oldParentNodeId = droppedNode?.parentNode?.id;
      const newOrder = newPathData.pathTo.pop() + 1;
      let newParentNode = this.rootNode;
      if( newPathData.pathTo.length ){ // Значит родитель где-то глубже
        newParentNode = this.$refs.elementsTree.getItemByPath(newPathData.pathTo)
      }
      const newParentNodeId = newParentNode?.id;


      const x = window.event?.clientX ?? 200;
      const y = window.event?.clientY ?? 150;
      const userChoice = await this.showElementDnDContextMenu(droppedNode, x, y);

      switch (userChoice) {

        case 'move':
          apply();
          newParentNode.hasChildren = true;
          droppedNode.parentNode = newParentNode;

          droppedNode.doDragAndDropAction({
            action: userChoice,
            oldParentNodeId,
            newParentNodeId,
            newOrder
          });

          break;

        case 'copy':
        case 'copy_with_child':
        case 'link':
          revert();
          await this.$nextTick();
          // Нужно пересчитать parent, т.к. дерево обновилось
          droppedNode = this.$refs.elementsTree.getItemById(droppedNode.id);
          newParentNode = this.$refs.elementsTree.getItemById(newParentNodeId);
          if( !newParentNode && newParentNodeId === this.rootNode.id ){
            newParentNode = this.rootNode;
          }
          if (!newParentNode) {
            break;
          }

          await droppedNode.doDragAndDropAction({
            action: userChoice,
            oldParentNodeId,
            newParentNodeId,
            newOrder
          });
          newParentNode.expand();
          break;
        case 'cancel':
          revert();
          return;
      }
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/css/project-variables";

.cascading-elements-tree-component{
  flex: 1;
  position: relative;
  display: flex;
  height: calc(100vh - 150px);
  flex-direction: column;
  //overflow: hidden;

  .view-mode-radio-group{
    .el-radio-button{
      input{
        &:disabled {
          &:checked + .el-radio-button__inner {
            background-color: $--color-primary;
          }
        }
      }
    }
  }
}
.cascading-elements-tree-table{
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
.cascading-elements-tree-settings-panel{
  border-top: 2px solid #E4E7ED;
  //padding-top: 20px;
  height: 250px;
  box-sizing: border-box;
  overflow-y: auto;
}
.cascading-elements-context-menu-overlay{
  width: 100%;
  height:100%;
  position: fixed;
  z-index: 9998;

  .cascading-elements-context-menu {
    position: fixed;
    z-index: 9999;
    padding: 3px 3px 0 3px;
    background: white;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
    width: 150px;
    border-radius: $--border-radius-base;

    button{
      margin-bottom: 3px;
      width: 100%;
    }
  }
}



.cascading-elements-tree {
  ol.nestable-list {
    margin-top: 0;
  }
  li ol.nestable-list {
    padding-left: 31px;
  }

  &-header {
    display: flex;
    //background-color: #f0f2f5;
    color: #909399;
    font-weight: bold;
    border-top: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  .nestable-item {
    margin: 0;
  }

  &-row-link {
    margin-left: 65px;
  }

  &-helper-icon{
    margin-right: 6px;
    color: #b4b4b4;
    font-size: 12px;

    &:last-child{
      margin-right: 0;
    }
  }

  &-row {
    //padding: 5px 0;
    border-bottom: 1px solid #EBEEF5;

    &.selected-row{
      background-color: #fff8e2 !important;
    }

    &-link {
      display: flex;
      //gap: 20px;
    }

    &-main {
      display: flex;
      //gap: 20px;
      align-items: center;
    }
  }

  &-cell {
    height:23px;
    padding: 8px 10px 4px 10px;
    border-right: 1px solid #EBEEF5;
  }

  &-row:hover {
    background-color: #f5f5f5;
  }
}




</style>